import type { HTMLProps } from 'react'
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'

import { CheckboxIcon } from './CheckboxIcon'
import * as S from './styled'
import type { CheckboxProps } from './types'

type CheckboxIndeterminateComponentProps = CheckboxProps & {
  indeterminate?: boolean
} & HTMLProps<HTMLInputElement>

export const CheckboxIndeterminateComponent = forwardRef(
  ({ indeterminate, ...rest }: CheckboxIndeterminateComponentProps, ref) => {
    const inputRef = useRef<HTMLInputElement>(null)
    const [isIndeterminate, setIsIndeterminate] = React.useState(false)

    useImperativeHandle(ref, () => ({
      inputRef: inputRef.current,
    }))

    useEffect(() => {
      if (inputRef.current && typeof indeterminate === 'boolean') {
        inputRef.current.indeterminate = !rest.checked && indeterminate
        setIsIndeterminate(!rest.checked && indeterminate)
      }
    }, [inputRef, indeterminate, rest.checked])

    return (
      <S.Container>
        <S.Label $disabled={Boolean(rest.disabled)} $labelAlign={rest.labelAlign}>
          {/* We need to wrap input in div to be able to position CheckboxIcon on top of it and correctly apply margins to label */}
          <div>
            <S.Input
              // @ts-ignore
              ref={inputRef}
              type="checkbox"
              {...rest}
            />
            <CheckboxIcon size="small" indeterminate={isIndeterminate} />
          </div>
        </S.Label>
      </S.Container>
    )
  },
)

export const CheckboxIndeterminate = React.memo(CheckboxIndeterminateComponent)
